import { useState } from 'react'
import { Box, Text } from '@chakra-ui/react'
import { DataList, DataTable } from '@minetrace/ui'
import { brand, themeColors } from '../../theme'
import { syncService } from '../../api/services'
import type { ReinfoRecord } from '../../api/services/sync.service'
import { usePagedRequest } from '../../hooks'
import SyncPageLayout from './SyncPageLayout'
import { useT } from '../../i18n'

export default function ReinfoPage() {
  const colors = themeColors
  const { t } = useT()
  const [search, setSearch] = useState('')

  const reinfo = usePagedRequest(syncService.getReinfo, {
    params: { search: search.trim() || undefined },
    pageSize: 25,
  })

  return (
    <SyncPageLayout
      title={t('sync.reinfo.title')}
      subtitle={t('sync.reinfo.subtitle')}
      syncType="Reinfo"
      onRefresh={() => reinfo.refresh()}
    >
      <DataList<ReinfoRecord>
        searchValue={search}
        onSearchChange={setSearch}
        searchPlaceholder={t('sync.searchPlaceholder')}
        page={reinfo.page}
        totalPages={reinfo.totalPages}
        onPageChange={reinfo.setPage}
        totalCount={reinfo.totalCount}
        entityName="registros REINFO"
        pageSize={reinfo.pageSize}
        onPageSizeChange={reinfo.setPageSize}
        brandColor={brand.primary}
        headers={[
          t('sync.reinfo.headers.ruc'),
          t('sync.reinfo.headers.miner'),
          t('sync.reinfo.headers.uniqueCode'),
          t('sync.reinfo.headers.miningRight'),
          t('sync.reinfo.headers.department'),
          t('sync.reinfo.headers.province'),
          t('sync.reinfo.headers.district'),
          t('sync.reinfo.headers.status'),
        ]}
        data={reinfo.items}
        loading={reinfo.isFetching}
        error={reinfo.error}
        emptyMessage={t('sync.reinfo.emptyMessage')}
        loadingMessage={t('sync.reinfo.loadingMessage')}
        colors={colors}
        keyExtractor={(r) => r.id}
        renderRow={(r) => (
          <>
            <DataTable.Cell>
              <Text fontFamily="monospace" fontSize="sm" color={colors.text}>{r.ruc}</Text>
            </DataTable.Cell>
            <DataTable.Cell>
              <Text fontSize="sm" fontWeight="500" color={colors.text}>{r.minerName}</Text>
            </DataTable.Cell>
            <DataTable.Cell>
              <Text fontFamily="monospace" fontSize="sm" color={colors.text}>{r.uniqueCode}</Text>
            </DataTable.Cell>
            <DataTable.Cell>
              <Text fontSize="sm" color={colors.text}>{r.miningRightName}</Text>
            </DataTable.Cell>
            <DataTable.Cell>
              <Text fontSize="sm" color={colors.text}>{r.department}</Text>
            </DataTable.Cell>
            <DataTable.Cell>
              <Text fontSize="sm" color={colors.text}>{r.province}</Text>
            </DataTable.Cell>
            <DataTable.Cell>
              <Text fontSize="sm" color={colors.text}>{r.district}</Text>
            </DataTable.Cell>
            <DataTable.Cell>
              <Box
                display="inline-block" px={2} py={0.5} borderRadius="md"
                fontSize="10px" fontWeight="bold" textTransform="uppercase"
                bg={r.estado === 'VIGENTE' ? 'rgba(42, 138, 135, 0.2)' : 'rgba(200, 68, 47, 0.2)'}
                color={r.estado === 'VIGENTE' ? '#2a8a87' : '#c8442f'}
              >
                {r.estado}
              </Box>
            </DataTable.Cell>
          </>
        )}
      />
    </SyncPageLayout>
  )
}
